import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DEFAULT_SPORT, SPORT_BY_ID } from "../constants/sportWorkspace";
import api from "../utils/api";
import {
  getDestinationFromPath,
  getSportFromPath,
  readStoredSport,
  switchSportPath,
  writeStoredSport,
} from "../utils/sportWorkspace";

const browserStorage = () =>
  typeof window === "undefined" ? null : window.localStorage;

export const useSportWorkspace = ({ storage } = {}) => {
  const store = storage === undefined ? browserStorage() : storage;
  const location = useLocation();
  const navigate = useNavigate();
  const pathSport = getSportFromPath(location.pathname);
  const [storedSport, setStoredSport] = useState(() => readStoredSport(store));

  useEffect(() => {
    if (!pathSport) return;
    writeStoredSport(pathSport, store);
    setStoredSport(pathSport);
  }, [pathSport, store]);

  const sport = pathSport || storedSport || DEFAULT_SPORT;
  const destination = getDestinationFromPath(location.pathname);
  const meta = SPORT_BY_ID[sport];

  const switchSport = useCallback(
    (nextSport) => {
      if (!SPORT_BY_ID[nextSport]) return;
      writeStoredSport(nextSport, store);
      setStoredSport(nextSport);
      if (store?.getItem?.("token")) {
        api.patch("/profile/me", { preferredSport: nextSport }).catch(() => {});
      }
      const nextPath = switchSportPath(location.pathname, nextSport);
      if (nextPath !== location.pathname) navigate(nextPath);
    },
    [location.pathname, navigate, store]
  );

  return useMemo(
    () => ({ sport, destination, meta, switchSport }),
    [destination, meta, sport, switchSport]
  );
};
